import { ApopsType, ProfileActionType, ProfileScoreMapperType } from "./types";

const apops: ApopsType = {
  warningInfo: "This is required to apply for this job",
  save: "Save",
  basicDetails: {
    basicDetails: "Basic Details",
    helpUsToUnderstand: "Help us understand you better",
    gender: "Gender",
    male: "Male",
    female: "Female",
    preferNotToSay: "Prefer not to say",
    enterTotalExp: "Enter Total Experience",
    years: "Years",
    months: "Months",
    currentLoc: "Current Location",
    shareYourCurrentCity: "Share your current city",
    enterYourCity: "Enter your city",
    yourNationality: "Your Nationality",
    selectYourNationality: "Select Your Nationality",
    workAuthFor: "Work authorization for",
    selectYourWorkAuth: "Select your work authorization",
    addVerifyMobileTxt: "Add and Verify Mobile Number",
    totalExpInfo: "If you are student/fresher choose 0 year and 0 month",
    fullName: "Full Name",
    fullNamePlaceholder: "Enter your full name",
    add: "Add Mobile Number",
  },
  educationDetails: {
    educationDetails: "Education Details",
    tellRecruitersAboutTxt:
      "Tell recruiters about your educational qualifications",
    highestQualification: "Highest Qualification",
    selectYourDegree: "Select your degree",
    enterYourQualification: "Enter Your Qualification",
    board: "Board",
    selectYourBoard: "Select your board",
    medium: "Medium",
    selectYourMedium: "Select your medium",
    percentage: "Percentage",
    selectYourPercentage: "Select your percentage",
    specializationMajor: "Specialization/Major",
    selectYourSpecialization: "Select your specialization",
    enterYourSpecialization: "Enter Your Specialization",
    universityInstitute: "University/Institute",
    selectYourUniversity: "Select your University",
    enterYourUniversityInstitute: "Enter Your University/Institute",
    yearOfGraduation: "Passing Year",
    selectYear: "Select year",
    educationType: "Education Type",
    error: {
      selectHighestQualificationError: "Select your highest qualification.",
      selectYourBoardError: "Select your board.",
      selectYourMediumError: "Select your medium.",
      selectYourPercentageError: "Select your percentage.",
      selectYourUniversityError: "Select your university/institute.",
      selectYourSpecializationError: "Select your specialization",
      yearOfGraduationError: "Select your passing year.",
      enterHighestQualificationError: "Enter your highest qualification.",
      enterYourSpecializationError: "Enter your Specialization.",
      enterYourInstituteError: "Enter your institute's name.",
      educationTypeError: "Select your Education type.",
    },
  },
  jobPreferences: {
    jobPreferences: "Job Preferences",
    helpsToFindBetter: "Helps to find better matching jobs",
    keySkills: "Key Skills",
    keySkillsPlaceholder: "Expert to beginner- flaunt them all!",
    maxKeySkillsPlaceholder: "Maximum 50 skills can be selected",
    industry: "Industry",
    industryTooltip:
      "Select industry you work in. For example, IT, Telecom, BPO.",
    industryPlaceholder: "Maximum 2 industries can be selected",
    departmentFunction: "Department / Function",
    departmentFunctionTooltip:
      "Select department you work in. For example, Finance, HR, Sales, IT.",
    departmentFunctionPlaceholder: "Maximum 2 functions can be selected",
    preferredRole: "Preferred Job Title",
    preferredRolePlaceholder: "Maximum 2 job title can be selected",
    preferedLocations: "Preferred Location(s)",
    preferedLocationsPlaceholder: "Add location(s) you want to work from",
    maxPreferedLocationsPlaceholder: "Maximum 5 locations can be selected",
    error: {
      skillsError: "Enter skill. At least one skill is required.",
      industriesError: "Enter industry. At least one industry is required.",
      functionsError: "Enter function. At least one function is required.",
      rolesError: "Enter job title. At least one job title is required.",
      locationsError: "Enter location. At least one location is required.",
    },
  },
  employmentDetails: {
    employmentDetailsHeading: "Employment Details",
    employmentDetailsSubHeading:
      "This is crucial for a recruiter to understand!",
    currentDesignation: "Current Job Title",
    designationPlaceholder: "Enter your job title",
    company: "Company",
    companyPlaceholder: "Enter your company name",
    startDate: "Start Date",
    endDate: "End Date",
    year: "Year",
    month: "Month",
    currentlyWorking: "Currently working here",
    currentSalary: "Current Salary",
    annual: "Annual",
    monthly: "Monthly",
    salaryPlaceholder: "Enter Salary",
    noticePeriod: "Notice Period",
    addEducation: "Next: Job Preference",
    hideSalaryPotential: "Hide my salary from potential employers",
    noticePeriodPlaceholder: "Select Notice Period",
    lastWorkDay: "Last Working Day",
    newOfferedSalary: "New Offered Salary",
    offeredDesignation: "Offered Job Title",
    searchOfferedDesignation: "Search offered job title",
    newCompany: "New Company",
    searchNewCompany: "Search new company",
  },
  autoUptodate: {
    warning:
      "Ensure recruiters see the most current version of your profile. You can easily disable this feature later in your settings.",
    autoUpdate: "Auto-Update",
    keep: "Keep my profile automatically up-to-date",
  },
};

const pendingAction: ProfileActionType = {
  profileTitle: "Profile Title",
  workAuth: "Work Authorization",
  resume: "Resume",
  education: "Education",
  employment: "Work Experience",
  noticePeriod: "Notice Period",
  nationality: "Nationality",
  skills: "Skills",
  courseCertification: "Course and Certification",
  projects: "Projects",
  verifyEmailId: "Verify Email Id",
  verifyMobileNumber: "Verify Mobile Number",
  addMobileNumber: "Add Mobile Number",
  userRegistration: "User Registration",
  industry: "Add Industry",
  function: "Preferred Function",
  role: "Preferred Job Title",
  preferredLocation: "Preferred Location",
  profilePicture: "Profile Picture",
  itSkill: "IT Skills",
  resumeUpdatedLastDays: "Resume Updated in last 90 days",
  workHistory: "Work History",
  summary: "Summary",
  totalWorkExperience: "Total Work Experience",
  languageKnown: "Language Known",
  preferredJobType: "Preferred Job Type",
  salary: "Salary",
  updateResume: "Update Resume",
};

export const focusOnField: ProfileActionType = {
  INDUSTRY: "industries",
  CURRENT_LOCATION: "location",
  JOB_PREFERENCES_ROLE: "roles",
  JOB_PREFERENCES_PREFERRED_LOCATION: "locations",
  KEY_SKILL: "skills",
  LINKEDIN: "url",
};

const linkedInTxt: string = "LinkedIn";

export const profileScoreMapper = (
  isRexMonster: boolean,
): ProfileScoreMapperType => {
  return {
    PROFILE_TITLE: {
      label: pendingAction.profileTitle,
      popup: "title",
    },
    WORK_AUTH: {
      label: pendingAction.workAuth,
      popup: "profile-card",
    },
    RESUME: {
      label: pendingAction.resume,
      popup: "resume",
    },
    EDUCATION: {
      label: pendingAction.education,
      popup: "education",
    },
    EMPLOYMENT: {
      label: pendingAction.employment,
      popup: "work",
    },
    NOTICE_PERIOD: {
      label: pendingAction.noticePeriod,
      popup: "work",
    },
    NATIONALITY: {
      label: pendingAction.nationality,
      popup: "notice-period",
    },
    KEY_SKILL: {
      label: pendingAction.skills,
      popup: "skills",
    },
    COURSE_AND_CERTIFICATION: {
      label: pendingAction.courseCertification,
      popup: "course",
    },
    PROJECTS: {
      label: pendingAction.projects,
      popup: "project",
    },
    VERIFY_EMAIL_ID: {
      label: pendingAction.verifyEmailId,
      popup: "email",
    },
    USER_REGISTRATION: {
      label: pendingAction.userRegistration,
      popup: "",
    },
    JOB_PREFERENCES_INDUSTRY: {
      label: pendingAction.industry,
      popup: "preference",
    },
    JOB_PREFERENCES_FUNCTION: {
      label: pendingAction.function,
      popup: "preference",
    },
    JOB_PREFERENCES_ROLE: {
      label: pendingAction.role,
      popup: "preference",
    },
    JOB_PREFERENCES_PREFERRED_LOCATION: {
      label: pendingAction.preferredLocation,
      popup: "preference",
    },
    PROFILE_PICTURE: {
      label: pendingAction.profilePicture,
      popup: "profile-card",
    },
    IT_SKILL: {
      label: pendingAction.itSkill,
      popup: "itSkills",
    },
    RESUME_UPDATED_IN_LAST_90_DAYS: {
      label: pendingAction.resumeUpdatedLastDays,
      popup: "resume",
    },
    WORK_HISTORY: {
      label: pendingAction.workHistory,
      popup: "work",
    },
    SUMMARY: {
      label: pendingAction.summary,
      popup: "summary",
    },
    TOTAL_WORK_EXPERIENCE: {
      label: pendingAction.totalWorkExperience,
      popup: "profile-card",
    },
    LANGUAGE_KNOWN: {
      label: pendingAction.languageKnown,
      popup: "language",
    },
    PREFERRED_JOB_TYPE: {
      label: pendingAction.preferredJobType,
      popup: "preference",
    },
    LINKEDIN: {
      label: linkedInTxt,
      popup: "online-presence",
    },
    CURRENT_LOCATION: {
      label: apops.basicDetails.currentLoc,
      popup: "profile-card",
    },
    GENDER: {
      label: apops.basicDetails.gender,
      popup: "profile-card",
    },
    ADD_AND_VERIFY_MOBILE_NUMBER: {
      label: isRexMonster
        ? apops.basicDetails.addVerifyMobileTxt
        : apops.basicDetails.add,
      popup: "mobile",
    },
    INDUSTRY: {
      label: pendingAction.industry,
      popup: "work",
    },
    SALARY: {
      label: pendingAction.salary,
      popup: "work",
    },
    EXPIRED_RESUME: {
      label: pendingAction.updateResume,
      popup: "resume",
    },
  };
};
